import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { SesionServicio } from '@nucleo/sesion/sesion-servicio';
import { SesionApiServicio } from '@nucleo/sesion/sesion-api-servicio';
import { RUTAS_APP } from '@app/rutas/app-rutas.const';
import { ParametroConsulta } from '@nucleo/modelos/parametro-consulta.enum';

/**
 * Protege las rutas privadas:
 * - sin sesión válida → login, conservando la URL solicitada;
 * - con contraseña temporal → pantalla de cambio obligatorio (el token no tiene permisos);
 * - sesión sin usuario cargado (p. ej. datos guardados incompletos) → consulta `GET /account/me`.
 */
export const autenticacionGuard: CanActivateFn = (_ruta, estado) => {
  const servicioSesion = inject(SesionServicio);
  const router = inject(Router);
  const urlInicioSesion = router.createUrlTree([RUTAS_APP.AUTENTICACION.absolutas.iniciarSesion()], {
    queryParams: { [ParametroConsulta.URL_RETORNO]: estado.url },
  });

  if (!servicioSesion.estaAutenticado()) {
    return urlInicioSesion;
  }
  if (servicioSesion.debeCambiarContrasena()) {
    return router.createUrlTree([RUTAS_APP.AUTENTICACION.absolutas.cambiarContrasena()]);
  }
  if (servicioSesion.usuario()) {
    return true;
  }
  return inject(SesionApiServicio)
    .cargarUsuarioActual()
    .pipe(
      map((usuario) =>
        usuario.mustChangePassword
          ? router.createUrlTree([RUTAS_APP.AUTENTICACION.absolutas.cambiarContrasena()])
          : true,
      ),
      catchError(() => {
        servicioSesion.limpiar();
        return of(urlInicioSesion);
      }),
    );
};
